// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"40":"9eb9368e","773":"dac4869d"}[chunkId] + ".chunk.css";
};